import React from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
const DeliveryMan = ({meta}) => {
  const columns = [
    { field: "id", header: "Id" },
    { field: "Completed", header: "Delivery Man" },
    { field: "Price", header: "Delivery Man Earn" },
    { field: "delivery", header: "Have Cash" },
    { field: "store", header: "Wallet Deduct" },
    { field: "admin", header: "Added In Wallet" },
    { field: "admin", header: "Transferred" },
    { field: "admin", header: "Pay Delivery Man" },
  ];

  // const data = [
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  //   {
  //     id: "1000",
  //     store: "579.00",
  //     Price: "590.00",
  //     Completed: "19 Apr 2024",
  //     delivery: "54.2",
  //     admin: "6.02",
  //   },
  // ];

  const data = [];
  const searchBy = {
    filterType: "Search By",
    inputName: "search_by",
    options: [
      {
        name: "User",
        code: "User",
      },
      {
        name: "Order no",
        code: "Order no",
      },
      {
        name: "Store",
        code: "Store",
      },
    ],
  };

  const filters = [
    {
      filterType: "delivery Type",
      inputName: "delivery_type",
      options: [
        {
          name: "Delivery",
          code: "Delivery",
        },
        {
          name: "Pickup",
          code: "Pickup",
        },
        {
          name: "Schedule",
          code: "Schedule",
        },
        {
          name: "Now",
          code: "Now",
        },
      ],
    },
    {
      filterType: "Select Payment Type",
      inputName: "select_payment_type",
      options: [
        {
          name: "Cash",
          code: "Cash",
        },
        {
          name: "Paystack",
          code: "Paystack",
        },
        {
          name: "Razorpay",
          code: "Razorpay",
        },
        {
          name: "Paytabs",
          code: "Paytabs",
        },
        {
          name: "Stripe",
          code: "Stripe",
        },
        {
          name: "Paypal",
          code: "Paypal",
        },
      ],
    },
  ];

  return (
    <div className='main-content'>
      <CommonLayout />
      <BasicTable
        data={data}
        columns={columns}
        SearchBy={searchBy}
        filters={filters}
        WeekRange={false}
        MonthRange={true}
      />
    </div>
  );
};

export default DeliveryMan;
